angular
	.module 'App.Module.VatRateOverrideGroupModule', []
	.config ($stateProvider, DEFAULT_RESOLVE_POLICY) ->
		$stateProvider
			.state 'vat_rate_override_group',
				url: '/vat_rate_override_groups',
				views:
					main:
						templateUrl: '@app/layout/views/app.entity-administration.view.html'
						controller: 'MainCrudController'
						controllerAs: 'mainCrud'

					'entity_search@vat_rate_override_group':
						templateUrl: '@app/layout/views/app.entity-search.view.html'
						controller: 'BaseSearchController'
						controllerAs: 'search'
				data:
					searchParams:
						repositoryName: 'VatRateOverrideGroupRepository'
						title: 'general.vat_rate_override_groups'
					restrict: 'Shared.Setting.VatRateOverride.Enabled'

			.state 'vat_rate_override_group.edit',
				url: '/:id'
				views:
					entity_view:
						templateUrl: '@app/layout/views/app.entity-container.view.html'
				resolvePolicy: DEFAULT_RESOLVE_POLICY
				resolve:
					vatRateOverrideGroup: (VatRateOverrideGroupRepository, $stateParams) ->
						return VatRateOverrideGroupRepository.getEntity $stateParams.id
					vatRates: (VatRateRepository) ->
						return VatRateRepository.getEntities()

			.state 'vat_rate_override_group.edit.details',
				url: '/edit',
				views:
					entity_sub_view:
						controller: 'VatRateOverrideGroupController'
						controllerAs: 'vm'
						templateUrl: '@app/vat-rate-override-group/vat-rate-override-group.view.html'
